import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {ReactiveFormsModule} from '@angular/forms';
import {TranslocoModule} from '@jsverse/transloco';

import {MatButtonModule} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
import {MatIconModule} from '@angular/material/icon';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';
import {MatSelectModule} from '@angular/material/select';
import {MatOptionModule} from '@angular/material/core';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatFormFieldModule} from '@angular/material/form-field';

import {CoreModule} from '../../core/core.module';
import {SettingsComponent} from './settings.component';
import {SettingsListComponent} from './settings-list/settings-list.component';
import {SettingsRestApiService} from './services/http/settings-rest-api.service';
import {WaitDownloadDialogComponent} from './wait-download-dialog/wait-download-dialog.component';
import {MatDialogContent, MatDialogTitle} from '@angular/material/dialog';

@NgModule({
  declarations: [
    SettingsComponent,
    SettingsListComponent,
    WaitDownloadDialogComponent
  ],
  imports: [
    CommonModule,
    TranslocoModule,
    RouterModule,
    ReactiveFormsModule,

    MatTableModule,
    MatProgressBarModule,
    MatSortModule,
    MatButtonModule,
    MatInputModule,
    MatIconModule,
    MatOptionModule,
    MatSelectModule,
    MatFormFieldModule,

    CoreModule,
    MatDialogContent,
    MatDialogTitle,
  ],
  providers: [
    SettingsRestApiService,
  ],
})
export class SettingsModule {
}
